import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { reportColumnAggregateTypesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import compact from "lodash/compact";
import mean from "lodash/mean";
import sum from "lodash/sum";
import Tooltip from "rc-tooltip";
import React, { Fragment } from "react";
import { list as logistsList } from "sources/books/employees";
import CommonReport from "./commonReport";

export default class GroupedByLogistReport extends CommonReport {
    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            Cell: (props) => {
                const { car } = props.row.values;
                const uniqueId = { [`data-${props.column.id}`.toLowerCase()]: car };
                switch (props.column.id) {
                    case "carLogistId": {
                        const { subRows } = props.row;
                        const logistName = subRows[0].original?.carLogistDisplayName || "Без логиста";
                        const rowCount = /\(\d+\)$/.test(logistName) ? "" : ` (${subRows.length})`;
                        return (
                            <span data-car-logist-id={props.value}>
                                {logistName}
                                {rowCount}
                            </span>
                        );
                    }
                    case "bids":
                        return (props.value || []).map(
                            ({ id, hasManualMileage, hasCarChange, hasDriverChange }, index) => (
                                <Fragment key={index}>
                                    <a
                                        data-bidid={id}
                                        href={paths.bidShow("bid", id)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {id}
                                    </a>
                                    {hasManualMileage && (
                                        <>
                                            &nbsp;
                                            <Tooltip overlay="Закрыта вручную">
                                                <i className="icon-uEA83-user-edit b-point__tooltip-icon" />
                                            </Tooltip>
                                        </>
                                    )}
                                    {(hasCarChange || hasDriverChange) && (
                                        <Tooltip
                                            overlay={`Произошла смена ${compact([
                                                hasCarChange ? "машины" : null,
                                                hasDriverChange ? "водителя" : null,
                                            ]).join(" и ")}`}
                                        >
                                            <span className="pl-1 icon-uEAB3-arrows-rotate b-point__tooltip-icon" />
                                        </Tooltip>
                                    )}
                                    <br />
                                </Fragment>
                            ),
                        );
                    case "bidIds":
                        return (props.value || "").split(", ").map((bidId, index) => (
                            <Fragment key={index}>
                                <a
                                    data-bidid={bidId}
                                    href={paths.bidShow("bid", bidId)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {bidId}
                                </a>
                                <br />
                            </Fragment>
                        ));
                    case "bidId":
                        return (
                            <a
                                data-bidid={props.value}
                                href={paths.bidShow("bid", props.value)}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {props.value}
                            </a>
                        );
                    default:
                        return (
                            <div className="long-text" {...uniqueId}>
                                {formatValue(props.value, column.clrType)}
                            </div>
                        );
                }
            },
            ...typeSpecificProps(column),
            aggregate: (leafValues) => {
                if (!this.numericClrTypes.includes(column.clrType)) {
                    return null;
                }
                switch (column.aggregateType) {
                    case reportColumnAggregateTypesEnum.Average:
                        return Math.round(mean(leafValues));
                    case reportColumnAggregateTypesEnum.Sum:
                        return sum(leafValues);
                    default:
                        return null;
                }
            },
            Aggregated: ({ value }) => {
                return value !== null ? <strong>{formatValue(value, column.clrType)}</strong> : "";
            },
            ...(column.propertyName === "CarLogistId"
                ? {
                      Filter: reportFilterWrapper((props) => (
                          <SelectColumnFilter
                              {...props}
                              selectProps={{
                                  ...defaultMultipleSelectProps,
                                  url: logistsList,
                                  inputProps: { name: "carLogistIds" },
                                  propName: "fullNameOrEmail",
                                  components: { ValueContainer },
                              }}
                          />
                      )),
                      filter: (rows, _id, filterValue) => {
                          if (!filterValue || !filterValue.value || filterValue.value.length === 0) {
                              return rows;
                          }
                          return rows.filter((row) => filterValue.value.includes(row.values.carLogistId));
                      },
                  }
                : {}),
        };
    };

    extractColumns = () => {
        const { columns } = this.props.data || {};
        return columns.map((column) => {
            if (column.propertyName === "CarLogistId") {
                column.label = "Логист";
            }
            return this.cellProps(column);
        });
    };

    tableExtraProps = () => {
        const { columns } = this.props.data || {};
        const hiddenColumns = columns
            .filter(
                (column) =>
                    column.isAdditionalColumn || column.isFooterData || column.propertyName === "CarLogistDisplayName",
            )
            .map(columnName);
        return {
            initialState: {
                hiddenColumns,
                groupBy: ["carLogistId"],
            },
        };
    };
}
